
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/my-account",
      function () {
        return require("private-next-pages/[lang]/my-account/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/my-account"])
      });
    }
  